videojs.addLanguage('en', {
	'Commentator': 'Комментатор',
	'Settings': 'Settings',
	'Back': 'Back'
});
